import { themedColor, useViewportSize } from '@lemonade-hq/cdk';
import { Button, MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import styled from 'styled-components';

const BackButton = styled(Button)`
  display: block;
  padding-left: 19px;
  padding-right: 19px;

  &:hover {
    text-decoration: none;
  }

  &:before {
    content: attr(data-title-small);
  }

  ${MEDIA_QUERIES.desktop`
        max-width: none;
        &:before {
            content: attr(data-title-large);
        }
    `}

  ${MEDIA_QUERIES.upToDesktop`
        text-transform: none !important;
        font-size: 1.4rem !important;
        color: ${themedColor('white')} !important;
        background: ${themedColor('primary')} !important;
        box-shadow: 0 11px 17px -12px ${themedColor('primary')} !important;
    `}
`;

interface BackToYourQuoteButtonProps {
  titleLarge: string;
  titleSmall: string;
  trackClick: () => void;
}

export const BackToYourQuoteButton: React.FC<BackToYourQuoteButtonProps> = ({ titleLarge, titleSmall, trackClick }) => {
  const { isMobileViewport } = useViewportSize();
  return (
    <BackButton
      flavor={isMobileViewport ? 'primary' : 'ghost'}
      size="tiny"
      onClick={trackClick}
      data-title-small={titleSmall}
      data-title-large={titleLarge}
    />
  );
};
